export default "__VITE_ASSET__DRaqX1Of__"